import { Badge } from "@/components/ui/badge";

export const PlaceholderPanel = ({
  title,
  bundle,
  description,
}: {
  title: string;
  bundle: string;
  description: string;
}) => (
  <div className="flex h-full flex-col items-start gap-2 rounded-md border border-dashed border-border/60 bg-muted/30 p-4">
    <div className="flex items-center gap-2">
      <h3 className="text-sm font-semibold">{title}</h3>
      <Badge variant="outline" className="text-[10px] uppercase tracking-wider">
        {bundle}
      </Badge>
    </div>
    <p className="text-xs text-muted-foreground">{description}</p>
  </div>
);
